import { render, staticRenderFns } from "./CustomDownloadButton.vue?vue&type=template&id=7285103c"
import script from "./CustomDownloadButton.vue?vue&type=script&lang=js"
export * from "./CustomDownloadButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports